/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {PageState} from '@/types/pages';
import {INITIALIZE_ISSUES} from '../actions/issues';

// defines the initial state for the reducer ...
export const initialState: PageState = {
  isInitialized : false
};

// defines the reducers ...
const reducers = {
  [INITIALIZE_ISSUES] : draft => {
    draft.isInitialized = true;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: PageState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
